module.exports = __webpack_public_path__ + "img/gireffe-hero.fe3293d2.png";